import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getPromotions } from "examsbook-react-sdk/actions";
import { isUrlAbsolute } from "examsbook-react-sdk/common";
import staticUrl from "RNExamsbookCommon/constants/staticUrl";

/**
 * get list of all saved questions.
 * @returns {*}
 */
export default function usePromotions(isVip = false, language = 'en', baseUrl = staticUrl.BASE_URL) {
    const dispatch = useDispatch();
    const promotions = useSelector((state) => state.promotions);
    let userType = "";
    if (isVip) {
        userType = "VIP";
    } else {
        userType = "FREE";
    }
    const imagesData = promotions && promotions.data && promotions.data.length && promotions.data
        .filter(
            (promotion) =>
                promotion.userType
                && promotion.languages
                && promotion.languages.includes(language)
                && promotion.userType
                && promotion.userType.includes(userType)
                && promotion.image
                && promotion.image.large
                && promotion.image.large.jpg
        )
        .map((promotion) => {
            return {
                id: promotion._id,
                image: isUrlAbsolute(promotion.image.large.jpg)
                    ? promotion.image.large.jpg
                    : baseUrl + promotion.image.large.jpg,
                action: promotion.action,
            };
        });

    const user = useSelector((state) => state.user);
    useEffect(() => {
        if (user && user.loggedIn) {
            dispatch(getPromotions());
        }
    }, [ user ]);
    return { promotionsBanners: imagesData, pending: promotions.pending };
}
